import { participantActionType } from '../../constants/index';

const initialState = {
    participantsAll: [],
    participantsAPISuccess: false,
    loading: false,
    error: null
};

const participantReducer = (state = initialState, action) => {
    switch (action.type) {
        case participantActionType.FETCH_PARTICIPANTS_ALL:
            return {
                ...state,
                participantsAll: action.payload,
                loading: false
            };
        case participantActionType.FETCH_PARTICIPANTS_SUCCESS:
            return {
                ...state,
                participantsAPISuccess: action.payload,
                loading: false
            };
        default:
            return state;
    }
};

export default participantReducer; 